import React from 'react';
import {observer} from "mobx-react";
import {BaseMatchedTransaction, TxType} from "../../../model/MatchedDocument";
import {Button, Dialog, DialogActions, DialogContent, Divider} from "@mui/material";
import InvoiceList, {InvoiceType} from "../../invoice/InvoiceList";
import MyMaterialTable from "../../../components/mtable/MyMaterialTable";
import TransactionTablesComponent from "./TransactionTablesComponent";
import {creditTableRowStyle, debitTableRowStyle} from "../../theme";
import moment from "moment";
import Big from "big.js";
import {formatPrice} from "../../../utils/NumberFormat";
import {BaseInvoiceListResponse} from "../../../model/invoice/BaseInvoiceListResponse";

interface IProps {
    itemToOverride: BaseMatchedTransaction,
    onOverride: (originalTx: BaseMatchedTransaction, invoices: BaseInvoiceListResponse[]) => any,
    onClose: () => any,
}

interface IState {
    invoices: BaseInvoiceListResponse[],
}

@observer
export default class OverrideInvoiceModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            invoices: []
        };
    }

    componentDidMount() {
    }

    render() {
        const tx = this.props.itemToOverride.tx;
        const txDate = moment(tx.txDate);
        return (<>
                    <Dialog onClose={this.closeModal} open={true} fullWidth={true} maxWidth={'md'}>
                        <DialogContent dividers>
                            {this.renderTxInfo()}
                            <Divider style={{margin: "0.5rem"}}/>
                            {this.renderSelectedItemsInfo()}
                            <Divider style={{margin: "0.5rem"}}/>
                            <InvoiceList withActions={false}
                                         fromDate={txDate.clone().subtract(2, 'month')}
                                         toDate={txDate.clone().add(2, 'month')}
                                         invoiceSelectionListener={this.invoiceSelectionChanged}
                                         type={tx.txType === TxType.CRDT ? InvoiceType.SALES : InvoiceType.PURCHASE}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                    disabled={!this.calculateSelectionInfo().diff.eq(Big(0))}
                                    autoFocus
                                    onClick={this.doOverride} variant="contained"
                                    color="primary">
                                Override
                            </Button>
                            <Button autoFocus onClick={this.closeModal} variant="contained" color="secondary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
        );
    }

    private renderSelectedItemsInfo() {
        const currency = this.props.itemToOverride.tx.currency;
        const info = this.calculateSelectionInfo();
        const data = [info]

        const diffColumnStyle = info.diff.eq(Big(0)) ? creditTableRowStyle : debitTableRowStyle;

        return <MyMaterialTable
                columns={[
                    {
                        title: 'Tx amount',
                        render: data => formatPrice(data.itemAmount, currency)
                    },
                    {
                        title: 'Invoices amount',
                        render: data => formatPrice(data.invoicesAmount, currency)
                    },
                    {
                        title: 'Difference',
                        render: data => formatPrice(data.diff, currency),
                        headerStyle: diffColumnStyle,
                        cellStyle: diffColumnStyle,
                    },
                ]}
                data={data}
                options={{
                    header: true,
                    toolbar: false,
                    search: false,
                    sorting: false,
                    paging: false,
                    draggable: false,
                }}
        />;
    }

    private calculateSelectionInfo = () => {
        const itemAmount = Big(this.props.itemToOverride.tx.amount);
        const invoicesAmount = this.state.invoices.map(it => Big(it.totalSum)).reduce((a, b) => a.plus(Big(b)), Big(0));

        const diff = itemAmount.sub(invoicesAmount);

        return {
            itemAmount,
            invoicesAmount,
            diff
        };
    }

    private renderTxInfo() {
        return <>
            <MyMaterialTable
                    columns={[
                        TransactionTablesComponent.txDateColumn(),
                        TransactionTablesComponent.txDescriptionColumn(),
                        TransactionTablesComponent.amountColumn(),
                        TransactionTablesComponent.txTypeColumn(),
                        {
                            field: 'tx.debtorName',
                            title: 'Dbtr Name',
                        },
                        {
                            field: 'tx.creditorName',
                            title: 'Cdtr Name',
                        },
                    ]}
                    data={[this.props.itemToOverride]}
                    options={{
                        header: true,
                        toolbar: false,
                        search: false,
                        sorting: false,
                        paging: false,
                        draggable: false,
                        rowStyle: row => row.tx.txType === TxType.CRDT ? creditTableRowStyle : debitTableRowStyle,
                    }}
            />
        </>
    }

    private invoiceSelectionChanged = (invoices: BaseInvoiceListResponse[]) => {
        this.setState({
            invoices
        })
    }

    private doOverride = () => {
        this.props.onOverride(this.props.itemToOverride, this.state.invoices);
    };

    private closeModal = () => {
        this.props.onClose();
    };

}